export default "__VITE_ASSET__BBvuIYgV__"